import { Button } from '@pickleballinc/react-ui';
import { Avatar } from '@pickleballinc/react-ui';

import { Country } from '@/entities/Country';
import { State } from '@/entities/State';
import { TeamLeaguePlayersInfo } from '@/entities/TeamLeaguePlayersInfo';
import { determinePlayerPhotoUrl } from '@/utils/determine-player-photo-url';

interface MovementsPlayerCardProps {
	player: TeamLeaguePlayersInfo;
	states: State[];
	countries: Country[];
	onAddPlayer: (player: TeamLeaguePlayersInfo) => void;
}

export function MovementsPlayerCard({ player, states, countries, onAddPlayer }: MovementsPlayerCardProps) {
	return (
		<div
			key={player.uuid}
			className="flex w-full flex-row items-center justify-between rounded-lg border border-violet-200 bg-violet-25 p-4 text-start text-sm shadow-md hover:border-gray-300"
		>
			<div className="flex gap-6">
				<div className="flex flex-col items-center text-xs">
					<Avatar size="xl" imageUrl={determinePlayerPhotoUrl(player.photo)} />
					<p className="max-w-[100px] text-center text-gray-900">
						{states.find((state) => parseInt(state.id.toString()) === player.stateId)?.title}
					</p>
					<p className="text-gray-500">{countries.find((country) => parseInt(country.id.toString()) === player.countryId)?.abbreviation}</p>
				</div>
				<div className="flex flex-col gap-1 text-xs">
					<p className="text-base font-semibold text-gray-900">
						{player.firstName} {player.lastName}
					</p>
					<p>
						Age: {player.age} | {player.gender === 'F' ? 'Female' : 'Male'}
					</p>
					<p>{player.email}</p>
					<p>{player.phone}</p>
					<div className="flex gap-1">
						<p>(D) {player.ratingDoubles !== null ? player.ratingDoubles.toFixed(2) : 'NR'}</p>
						<p>(S) {player.ratingSingles !== null ? player.ratingSingles.toFixed(2) : 'NR'}</p>
					</div>
				</div>
			</div>
			<Button className="w-fit self-end" size="xs" variant="primary" onClick={() => onAddPlayer(player)}>
				<p className="text-xs font-semibold text-white">Select</p>
			</Button>
		</div>
	);
}
